import { useState, ReactNode } from "react";
import HeartIcon from "../../../assets/icons/heart";
import AppButton from "../../AppButton";
import "../../ApiKeys/ApiKeys.css";
import CreateKeyModal from "../CreateKeyModal";

interface EmptyStateProps {
  icon?: ReactNode;
  iconClassName?: string;
  
  title: string;
  description: string;
  buttonText: string;
  
  buttonVariant?: "primary" | "secondary" | "tertiary";
  buttonType?: "modal" | "redirect"; 
  onButtonClick: () => void;
  
  modalComponent?: ReactNode | ((props: { isVisible: boolean; setIsModalVisible: () => void; onSuccess: () => void }) => ReactNode);
  
  className?: string;
  
  triggerRefetch?: () => void;
}

const ApiNoContent = ({
  icon = <HeartIcon className="api-keys__heart-icon" />,
  iconClassName = "",
  title = "No Platform Added Yet",
  description = "Let's get you started! Click the button to generate your first API key.",
  buttonText = "Add Platform",
  buttonType = "modal", 
  onButtonClick = () => {},
  modalComponent,
  className = "api-keys__empty-state",
  triggerRefetch
}: EmptyStateProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleButtonClick = () => {
    if (buttonType === "modal") {
      setIsModalOpen(true);
    }
    onButtonClick();
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleModalSuccess = () => {
    setIsModalOpen(false);
    triggerRefetch?.();
  };

  return (
    <div className={className}>
      <div className="api-keys__icon">
        {typeof icon === 'string' ? (
          <div className={iconClassName}>{icon}</div>
        ) : (
          icon
        )}
      </div>
      
      <h3 className="api-keys__empty-title">{title}</h3>
      
      <p className="api-keys__empty-description">{description}</p>
      
      <div className="api-keys_button">
        <AppButton variant="secondary" onClick={handleButtonClick}>
          {buttonText}
        </AppButton>
      </div>
      
      {buttonType === "modal" && modalComponent ? (
        typeof modalComponent === 'function' ? (
          (modalComponent as (props: { isVisible: boolean; setIsModalVisible: () => void; onSuccess: () => void }) => ReactNode)({
            isVisible: isModalOpen,
            setIsModalVisible: handleModalClose,
            onSuccess: handleModalSuccess
          })
        ) : (
          modalComponent
        )
      ) : buttonType === "modal" ? (
        <CreateKeyModal
          isVisible={isModalOpen}
          setIsModalVisible={setIsModalOpen}
          onKeyCreated={handleModalSuccess}
        />
      ) : null}
    </div>
  );
};

export default ApiNoContent;
